import React, { Component } from 'react'
import $ from 'jquery'
import axios from 'axios';
import imgRemoveBtn from '../../../static/image/v2/imgRemoveBtn.png'
import imgAddBtn from '../../../static/image/v2/popup/imgAddBtn.png'
import '../../../static/css/popup.css';

import closeV2 from '../../../static/image/v2/popup/closeV2.png'
import {closePopup} from "../../../static/js/Common2";
import { ORDER_API } from 'constants/apiUrls';

class ShopInfo2PopupV2 extends Component {
  componentDidMount() {
    
  }

  handleChange = (e) => {  // <- input값으로 text 변경 함수
    let file = e.target
    
    // 이미지 정보 인코딩
    var fileReader = new FileReader()
    fileReader.onload = (base64) => {
      const image = new Image()
      var size = file.files[0].size
      image.src = base64.target.result

      image.onload = (e) => {
        var arr1 = file.files[0].name.split('.');
        var arr2 = base64.target.result.split(',');
        var fileImg = []

        if(size <= 3072000) {
          $(`.newImg1`).attr('src', base64.target.result)

          fileImg.push({
            imageType: 8,
            encodedFile: arr2[1],
            fileName: arr1[0] + "_8",
            fileExtension: arr1[1]
          })
        }

        $('.imgRemoveBtn1').removeClass('hide')
        this.setState({fileList: fileImg})
      }
    }
    fileReader.readAsDataURL(file.files[0]);
  }

  handleChange2 = (e) => {  // <- input값으로 text 변경 함수
    let file = e.target
    let dataset = e.target.dataset
    let fileId = dataset.id
    
    // 이미지 정보 인코딩
    var fileReader = new FileReader()
    fileReader.onload = (base64) => {
      const image = new Image()
      var size = file.files[0].size
      image.src = base64.target.result

      image.onload = (e) => {
        var arr1 = file.files[0].name.split('.');
        var arr2 = base64.target.result.split(',');
        var fileImg = []

        if(size <= 3072000) {
          $(`.newImg2`).attr('src', base64.target.result)

          fileImg.push({
            id: Number(fileId),
            encodedFile: arr2[1],
            fileName: arr1[0] + "_8",
            fileExtension: arr1[1]
          })
        }

        $('.imgRemoveBtn2').removeClass('hide')
        this.setState({modiFile: fileImg})
      }
    }
    fileReader.readAsDataURL(file.files[0]);
  }

  removeImg = (e) => {
    $('#shopLogoImg').val('')
    $('.newImg1').attr('src', '')
    $('.imgRemoveBtn1').addClass('hide')

    this.setState({fileList: []})
  }
  removeImg2 = (e) => {
    $('#shopLogoImg2').val('')
    $('.newImg2').attr('src', '')
    $('.imgRemoveBtn2').addClass('hide')

    this.setState({modiFile: []})
  }

  constructor() {
    super()

    this.state={
      fileList: [],
      modiFile: []
    }
  }

  render() {
    // 세션 상점정보 조회
    const orderUrl = ORDER_API
    let shopId = Number(this.props.shopId)
    let fileList = this.state.fileList
    let modiFile = this.state.modiFile


    $('.shopInfo2PopupBtn').off('click').on('click', function() {
      if(fileList.length === 0) {
        alert('이미지를 업로드해주세요')
        return false
      } else {
        axios.put(`${ orderUrl }/shop/v2/${ shopId }`, {
          addImageFileList: fileList
        }).then(function() {
          window.location.reload()
        })
      }
    })
    $('.shopInfoModi2PopupBtn').off('click').on('click', function() {
      if(modiFile.length === 0) {
        alert('이미지를 업로드해주세요')
        return false
      } else {
        axios.put(`${ orderUrl }/shop/v2/${ shopId }`, {
          setImageFileList: modiFile
        }).then(function() {
          window.location.reload()
        })
      }
    })

    return (
      <div>
        <div id="shopInfo2Popup" className='shopInfo2Popup popupV2 hide'>
          <div className='popupContainer width578'>
            <div className='popupTitle'>
              <h2>대표이미지 등록</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopInfo2Popup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>대표이미지</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='shopLogoImgBtnBox'>
                  <input id='shopLogoImg' name='shopLogoImg' type='file' accept='image/jpeg, image/png' onChange={this.handleChange} hidden />
                  <label htmlFor='shopLogoImg' id='shopLogoImgBtn'>
                    <img src={ imgAddBtn } alt='로고 변경' />
                  </label>
                  <p>※ 대표이미지 권장 사이즈 600*462 , 800*615, 1080*840, 3MB이하의 jpg 또는 png 파일만 가능합니다.</p>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='imgBox'>
                  <img className='newImg newImg1' src='' alt='' onError={ this.handleImgError } />
                  <button className='imgRemoveBtn imgRemoveBtn1 hide'>
                    <img src={ imgRemoveBtn } alt='' onClick={ this.removeImg } />
                  </button>
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopInfo2Popup")}>취소</button>
              <button type='button' className='shopInfo2PopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>

        <div id="shopInfoModi2Popup" className='shopInfoModi2Popup popupV2 hide'>
          <div className='popupContainer width578'>
            <div className='popupTitle'>
              <h2>대표이미지 수정</h2>
              <button className='closeBtn stopCloseBtn' onClick={() => closePopup("shopInfoModi2Popup")}>
                <img src={ closeV2 } alt='취소' />
              </button>
            </div>
            <div className='popupContent'>
            <div className='popupFlexBox popupFlexBox1'>
                <div className='flexTitle'>대표이미지</div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='shopLogoImgBtnBox'>
                  <input id='shopLogoImg2' name='shopLogoImg' type='file' data-id='0' accept='image/jpeg, image/png' onChange={this.handleChange2} hidden />
                  <label htmlFor='shopLogoImg2' id='shopLogoImgBtn2'>
                    <img src={ imgAddBtn } alt='로고 변경' />
                  </label>
                  <p>※ 대표이미지 권장 사이즈 600*462 , 800*615, 1080*840, 3MB이하의 jpg 또는 png 파일만 가능합니다.</p>
                </div>
              </div>
              <div className='popupFlexBox popupFlexBox1'>
                <div className='imgBox'>
                  <img className='newImg newImg2' src='' alt='' onError={ this.handleImgError } />
                  <button className='imgRemoveBtn imgRemoveBtn2 hide'>
                    <img src={ imgRemoveBtn } alt='' onClick={ this.removeImg2 } />
                  </button>
                </div>
              </div>
            </div>
            <div className='popupBtn'>
              <button type='button' className='closeBtn' onClick={() => closePopup("shopInfoModi2Popup")}>취소</button>
              <button type='button' className='shopInfoModi2PopupBtn blueBtn'>확인</button>
            </div>
          </div>
        </div>
      </div>
      
    )
  }
}

export { ShopInfo2PopupV2 };